<template>
  <div class="flex gap-x-4 gap-y-2 w-full flex-wrap">
    <div
      v-for="caption in captions"
      :key="caption.label"
      class="flex items-center gap-2"
    >
      <LightningChargeFill
        v-if="caption.type === 'icon'"
        class="!w-3 !h-3 text-orange-600"
        aria-hidden="true"
      />
      <div
        v-else
        :class="{
          'w-[20px] h-[5px] rounded': caption.type === 'line',
          'w-[4px] h-[4px] rounded mx-auto my-0': caption.type === 'dot',
        }"
        :style="`background: ${caption.color}`"
      ></div>
      <div class="font-normal text-xs">{{ caption.label }}</div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { buyBoxDatePickerMarkerColors } from '~/composables/useEventBuyBoxDatePicker'
import LightningChargeFill from '~/assets/icons/lightning-charge-fill.svg?component'

const { t } = useI18n()

export type BuyBoxDatePickerCaptionIds =
  | 'publicDate'
  | 'privateDate'
  | 'instantDate'
  | 'soldOut'
  | 'dateRequest'
  | 'sale'

const props = withDefaults(
  defineProps<{
    disable?: BuyBoxDatePickerCaptionIds[]
  }>(),
  {
    disable: () => [],
  }
)

const captions = computed(() => {
  const arr: {
    id: BuyBoxDatePickerCaptionIds
    label: string
    color: string
    type: 'dot' | 'line' | 'icon'
  }[] = [
    {
      id: 'publicDate',
      label: t('product.show.datePickerCaptions.publicDateLabel'),
      color: buyBoxDatePickerMarkerColors.PUBLIC,
      type: 'line',
    },
    {
      id: 'privateDate',
      label: t('product.show.datePickerCaptions.privateDateLabel'),
      color: buyBoxDatePickerMarkerColors.PRIVATE,
      type: 'line',
    },
    {
      id: 'instantDate',
      label: t('product.show.datePickerCaptions.instantDateLabel'),
      color: buyBoxDatePickerMarkerColors.INSTANT,
      type: 'dot',
    },
    {
      id: 'soldOut',
      label: t('dateRequest.status.soldOut'),
      color: buyBoxDatePickerMarkerColors.red,
      type: 'line',
    },
    {
      id: 'sale',
      label: t('product.show.datePickerCaptions.saleLabel'),
      color: '',
      type: 'icon',
    },
    // {
    //   id: 'dateRequest',
    //   label: t('product.show.datePickerCaptions.dateRequestLabel'),
    //   color: '#CBD5E1',
    //   type: 'dot',
    // },
  ]
  return arr.filter((x) => !props.disable.includes(x.id))
})
</script>
